// import { SetCreateRequest, SetSearchFilter, SetSearchResponse, SessionSet } from '@api/entities';
import { ProgramSessionSet, ProgramSessionSetSearchRequest, SessionSet, SetCreateRequest, SetSearchFilter, SetSearchResponse } from 'src/api/entities';
import { IWorkoutSetApiService, WorkoutSetApiService } from '../services/workoutSet/workout.set.api.service';
import { AxiosResponse } from 'axios';

export interface IWorkoutSetManager {
    search(page: number, size: number, query?: string, sort?: { [key: string]: string | undefined }, filter?: SetSearchFilter): Promise<SetSearchResponse>;
    create(request: SetCreateRequest): Promise<SessionSet> ;
}

export class WorkoutSetManager implements IWorkoutSetManager {
    private static instance: WorkoutSetManager;
    private workoutService: IWorkoutSetApiService;

    private constructor() {
        this.workoutService = WorkoutSetApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (WorkoutSetManager.instance == null) {
            WorkoutSetManager.instance = new WorkoutSetManager();
        }
        return WorkoutSetManager.instance;
    }

    async search(workoutID?: number): Promise<SetSearchResponse> {
      const filter : SetSearchFilter = {
        sessionID: workoutID
      }  
      
      const response: SetSearchResponse = await this.workoutService.search(
          0, 
          100, 
          undefined, 
          undefined, 
          filter);
        return response;
    }

    async create(request: SetCreateRequest): Promise<SessionSet> {
        const response = await this.workoutService.create(request)
        return response;
    }

    async edit(oldExercise: SessionSet, updatedExercise: SessionSet): Promise<SessionSet> {
        const response = await this.workoutService.edit(oldExercise, updatedExercise)
        return response;
    }
  
    async getByID(id: number): Promise<SessionSet> {
        const response = await this.workoutService.getById(id)
        return response;
    }
  
    async delete(uuid: string): Promise<{ [key: string]: boolean; }> {
        const response = await this.workoutService.deleteByUuid(uuid)
        return response;
    }

    async createSessionSetSheet(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: SetSearchFilter
    ): Promise<Blob> {
        const response = await this.workoutService.createSessionSetSheet(page, size, query, sort, filter)
        return response;
    }
}
